import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { CancelPopupComponent } from './material-dialog/cancel-popup/cancel-popup.component';
import { ConfirmCancelPopupComponent } from './material-dialog/confirm-cancel-popup/confirm-cancel-popup.component';
import { DeletePopupComponent } from './material-dialog/delete-popup/delete-popup.component';
import { DeleteSnackbarComponent } from './material-dialog/delete-snackbar/delete-snackbar/delete-snackbar.component';
import { UndoSnackbarComponent } from './material-dialog/delete-snackbar/undo-snackbar/undo-snackbar.component';
import { EmailRecipientsComponent } from './material-dialog/email-recipients/email-recipients.component';
import { EmailStatusComponent } from './material-dialog/email-status/email-status.component';
import { EventsTagsImageComponent } from './material-dialog/events-tags-image/events-tags-image.component';
import { FailurePopupComponent } from './material-dialog/failure-popup/failure-popup.component';
import { InternetLostComponent } from './material-dialog/internet-lost/internet-lost.component';
import { LivestreamTicketBuyerListComponent } from './material-dialog/livestream-ticket-buyer-list/livestream-ticket-buyer-list.component';
import { NewChannelExperienceComponent } from './material-dialog/new-channel-experience/new-channel-experience.component';
import { SeasonTicketBuyersListComponent } from './material-dialog/season-ticket-buyers-list/season-ticket-buyers-list.component';
import { SeasonTicketListPopupComponent } from './material-dialog/season-ticket-list-popup/season-ticket-list-popup.component';
import { SuccessPopupComponent } from './material-dialog/success-popup/success-popup.component';
import { UsersListComponent } from './material-dialog/users-list/users-list.component';
import { VideoBuyersListComponent } from './material-dialog/video-buyers-list/video-buyers-list.component';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';
import { PipesModule } from './pipe/pipe.module';
import { CustomReuseStrategy } from './route-re-use';
import { AuthService } from './shared/auth.service';
import { applyDaterangepickerPatch } from './shared/daterangepicker.patch';
import { CommandSystemChangesComponent } from './material-dialog/command-system-changes/command-system-changes.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ModalPopupComponent,
    DeletePopupComponent,
    SuccessPopupComponent,
    CancelPopupComponent,
    ConfirmCancelPopupComponent,
    InternetLostComponent,
    SeasonTicketListPopupComponent,
    SeasonTicketBuyersListComponent,
    LivestreamTicketBuyerListComponent,
    FailurePopupComponent,
    EmailStatusComponent,
    UsersListComponent,
    NewChannelExperienceComponent,
    VideoBuyersListComponent,
    EventsTagsImageComponent,
    EmailRecipientsComponent,
    DeleteSnackbarComponent,
    UndoSnackbarComponent,
    CommandSystemChangesComponent
  ],
  imports: [
    BrowserModule,
    MatSlideToggleModule,
    HttpClientModule,
    AppRoutingModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions(undefined, environment.firebase.locationId)),
    provideStorage(() => getStorage()),
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatTableModule,
    BrowserAnimationsModule,
    MatDialogModule,
    NgxSkeletonLoaderModule.forRoot(),
    PipesModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    MatChipsModule,
    MatFormFieldModule,
    MatMenuModule,
    MatDividerModule,
    MatAutocompleteModule,
    CdkScrollableModule,
    MatTooltipModule
  ],
  providers: [
    AuthService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
          applyDaterangepickerPatch();
        },
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
